<template lang="pug">
  .clock(style="text-align: center")
    svg(:width="width", :height="height")
      g(:transform="'translate(' + width/2 + ', ' + height/2 + ')'")
        text(text-anchor="middle", y="18").text {{label}}

        path(:d="arcFull").clock-background
        path(:d="arcPath").clock
</template>

<script>

import * as d3 from 'd3'

export default {
  name: 'RadialClock',
  props: {
    label: {
      type: String,
      default: '00:15'
    },
    max: {
      type: Number,
      default: 60
    },
    value: {
      type: Number,
      default: 15
    }
  },
  data () {
    return {
      width: 200,
      height: 220,
      innerRadius: 75,
      outerRadius: 100
    }
  },
  computed: {
    ratio () {
      return (this.value + 0.001) / (this.max + 0.001)
    },
    arcFull () {
      return d3.arc()({
        innerRadius: this.innerRadius,
        outerRadius: this.outerRadius,
        startAngle: 0,
        endAngle: 2 * Math.PI
      })
    },
    arcPath () {
      return d3.arc()({
        innerRadius: this.innerRadius,
        outerRadius: this.outerRadius,
        startAngle: 0,
        endAngle: 2 * Math.PI * this.ratio
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.clock-background
  fill #ccc
.clock
  fill #00d1b2
.text
  fill #000
  font-size 42px
</style>
